export default __webpack_public_path__ + "static/media/bell.8e1f6393.svg";